export default __webpack_public_path__ + "static/media/hape-turtle-maze-2.3ac5e47d.jpg";